declare module '*.ttl' {
  const content: string
  export default content
}
